
import { Poster } from "./poster";
export class Video {
	constructor(
	  public id: number = 0,
	  public id_other: number = 0,
	  public timestamp: Date = new Date(),
	  public visible: boolean = true,  
	  public title: string = "",
	  public date: Date = new Date(),
	  public content: string = "",	  
	  public author: string = (typeof document !== 'undefined' && document.querySelector(".loginName") ? document.querySelector(".loginName").innerHTML : "unknown"),
	  
	  public imageUrl: string = "",
	  public imageAltText: string = "",
	  public sitegroup: string = "",
	  public friendlyUrl: string = "",
	  public keywords: string = "",
	  public description: string = "",
	  public teaser: string = "",
	  public titletag: string = "",
	  public posterUrl: string = "",
	  public posterAltText: string = "",
	  public posters: Array<Poster> = [],
	  public video: string = "",
	  public views: number = 0,
	 
	) {}
  
  
  }
  